import { useContext, useEffect, useState } from "react";

import Typography from "@mui/material/Typography";
import { Divider, Stack } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";

import logo from "../assets/imgs/logo.svg";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { dashboardSettings } from "../utils/dashboardSettingsConstants";
import { MenuContext } from "../App";
import { DataContext } from "../contexts/DataContext";

export const Link = (props: React.ComponentProps<typeof RouterLink>) => {
    return <RouterLink {...props} style={{ textDecoration: "none", color: "black" }} />;
};
export const Header = () => {
    const { t } = useTranslation();

    const { selectedMenu } = useContext(MenuContext);
    const dataContext = useContext(DataContext);
    const uploaded = !!dataContext.data;

    // Show who's logged in (next to Log out). /api/auth/userinfo returns the OIDC session; `name` is present
    // when the Auth0 connection supplies it, otherwise we fall back to the email (always present).
    const [user, setUser] = useState<{ email?: string; name?: string } | null>(null);
    useEffect(() => {
        fetch("/api/auth/userinfo")
            .then((r) => (r.ok ? r.json() : null))
            .then((d) => setUser(d?.userinfo ?? null))
            .catch(() => {});
    }, []);
    return (
        <Stack height="100px" width="100%" boxShadow="0px 4px 6px 0px rgba(0,0,0,0.25)" sx={{ backgroundColor: "#FFFFFF" }}>
            <Stack width={dashboardSettings.containerWidth} direction="row" alignItems="center" m="auto" justifyContent="space-between">
                <Stack direction="row" alignItems="center" spacing={2}>
                    {/* Logo doubles as home / back-to-upload (the old red "New File" text was unclear and oddly placed). */}
                    <Link to="/upload" aria-label={t("header.newFile")}>
                        <img src={logo} alt="Joint Impact Model — upload a new file" title={t("header.newFile")} style={{ display: "block", cursor: "pointer" }} />
                    </Link>
                </Stack>
                {uploaded && (
                    <Stack direction="row" alignItems="center" spacing={7} mx={3} ml="auto">
                        <Stack>
                            <Link to="/dashboard">
                                <Typography fontSize="24px"> {t("header.overview")}</Typography>
                            </Link>
                        </Stack>
                        <Stack>
                            <Link to="/ghg">
                                <Typography fontSize="24px" color={selectedMenu === "ghg" ? "#407243" : "222222"}>
                                    {t("header.ghg")}
                                </Typography>
                            </Link>
                        </Stack>
                        <Stack>
                            <Link to="/jobs">
                                <Typography fontSize="24px" color={selectedMenu === "jobs" ? "#96212D" : "222222"}>
                                    {t("header.jobs")}
                                </Typography>
                            </Link>
                        </Stack>
                        <Stack>
                            <Link to="/valueadded">
                                <Typography fontSize="24px" color={selectedMenu === "valueAdded" ? "#E38B06" : "222222"}>
                                    {t("header.valueadded")}
                                </Typography>
                            </Link>
                        </Stack>
                    </Stack>
                )}
                {uploaded && <Divider orientation="vertical" variant="middle" flexItem sx={{ border: "solid 1px", mx: 3 }} />}
                <Stack direction="row" alignItems="center" spacing={2}>
                    {(user?.name || user?.email) && (
                        <Typography
                            fontSize="16px"
                            sx={{ color: "#666", whiteSpace: "nowrap", maxWidth: 280, overflow: "hidden", textOverflow: "ellipsis" }}
                            title={user?.email}
                        >
                            {user?.name ?? user?.email}
                        </Typography>
                    )}
                    <Link to="/api/auth/logout" reloadDocument>
                        <Typography fontSize="24px" display="flex" alignItems="center" sx={{ cursor: "pointer" }}>
                            {t("header.logout")} <LogoutIcon sx={{ ml: 1 }} />
                        </Typography>
                    </Link>
                </Stack>
            </Stack>
        </Stack>
    );
};
